"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { MapPin, Camera, Clock, CheckCircle } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { useState } from "react";
export default function LocationScoutingAndManagement() {
  const {
    ref: imageRef,
    isVisible: imageVisible
  } = useRevealOnScroll({
    threshold: 0.3
  });
  const {
    ref: contentRef,
    isVisible: contentVisible
  } = useRevealOnScroll({
    threshold: 0.3
  });
  const [hoveredBullet, setHoveredBullet] = useState<number | null>(null);
  const benefits = [{
    icon: MapPin,
    text: "Comprehensive site surveys and location permits"
  }, {
    icon: Camera,
    text: "Professional scouting photography and documentation"
  }, {
    icon: Clock,
    text: "Timeline coordination and logistics planning"
  }];
  return <section className="relative py-16 md:py-24 bg-background overflow-hidden">
      <div className="container mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          {}
          <div ref={imageRef} className="relative aspect-video rounded-lg overflow-hidden shadow-medium transition-all duration-[var(--duration-slow)] ease-[var(--ease-out-back)]" style={{
          transform: imageVisible ? "translateX(0)" : "translateX(-3rem)",
          opacity: imageVisible ? 1 : 0,
          transitionDelay: "100ms"
        }}>
            <div className="absolute inset-0 bg-cover bg-center transition-transform duration-[var(--duration-slow)] ease-[var(--ease-smooth)]" style={{
            backgroundImage: "url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1520135/img/location_scouting_scene.png)",
            transform: hoveredBullet !== null ? "scale(1.02)" : "scale(1)"
          }} />
            <div className="absolute inset-0 bg-dark-background/15" />
          </div>

          {}
          <div ref={contentRef} className="space-y-6 transition-all duration-[var(--duration-slow)] ease-[var(--ease-out-back)]" style={{
          transform: contentVisible ? "translate(0, 0)" : "translate(2rem, 1rem)",
          opacity: contentVisible ? 1 : 0,
          transitionDelay: "200ms"
        }}>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-display font-bold text-foreground leading-tight">
              Location Scouting and Management
            </h2>

            <p className="text-base md:text-lg text-muted-foreground leading-relaxed">
              Our expert team handles every aspect of location discovery and coordination, ensuring your production has the perfect backdrop. From initial scouting to final permits, we manage the logistics so you can focus on creating.
            </p>

            <ul className="space-y-4">
              {benefits.map((benefit, i) => {
              const Icon = benefit.icon;
              return <li key={i} data-index={i} className="flex items-start gap-3 transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] cursor-default" style={{
                transform: hoveredBullet === i ? "translateY(-0.25rem)" : "translateY(0)"
              }} onMouseEnter={() => setHoveredBullet(i)} onMouseLeave={() => setHoveredBullet(null)}>
                    <Icon className="size-5 text-primary mt-0.5 shrink-0 transition-transform duration-[var(--duration-medium)] ease-[var(--ease-spring)]" />
                    <span className="text-foreground leading-relaxed">{benefit.text}</span>
                  </li>;
            })}
            </ul>

            <div className="pt-4">
              <Link to="/" className="inline-block">
                <Button variant="outline" size="lg" className="transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] hover:bg-primary-active hover:text-foreground-primary hover:border-primary hover:scale-[1.02] hover:shadow-medium">
                  <CheckCircle className="size-5" />
                  Explore Our Services
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>;
}